"use strict";
import _ from "lodash";
import configStore from "../../stores/configStore";
import createClasses from "../createClasses";
import L from "../../leaflet";
import getHashtagFromNode from "../drawerHelper";
import getArrowIcon from "../geoIcons";
const fallback = (container, node) => {
  var _a, _b;
  let { i18n, images, locale, defaultLocale, filters } = configStore.getState();
  defaultLocale = ((_a = node == null ? void 0 : node.extendedData) == null ? void 0 : _a.defaultLocale) || defaultLocale;
  if (!_.isEmpty(node.imageUrl)) {
    const image = L.DomUtil.create(
      "img",
      "decidimGeo__drawer__listCardImg decidimGeo__drawer__listCardImg--large",
      container
    );
    image.src = node.imageUrl;
    container.className += " decidimGeo__drawer__listCardInfo--image";
  }
  const infoType = L.DomUtil.create("div", "decidimGeo__drawer__listCardType", container);
  const infoTxt = L.DomUtil.create(
    "span",
    createClasses("decidimGeo__drawer__listCardTxt"),
    infoType
  );
  infoTxt.textContent = i18n[node.resourceType];
  const infoTitle = L.DomUtil.create(
    "div",
    "decidimGeo__drawer__listCardTitle",
    container
  );
  const infoTitleTxt = L.DomUtil.create(
    "span",
    createClasses("decidimGeo__drawer__listTitleTxt"),
    infoTitle
  );
  infoTitleTxt.textContent = getHashtagFromNode(node, locale, defaultLocale);
  const hasAssemblyOrProcess = filters == null ? void 0 : filters.some(
    (f) => f.assembly_filter || f.process_filter
  );
  if (((_b = node == null ? void 0 : node.extendedData) == null ? void 0 : _b.componentUrl) && !hasAssemblyOrProcess) {
    const infoChild = L.DomUtil.create(
      "div",
      createClasses("decidimGeo__drawer__listCardChild"),
      infoTitle
    );
    infoChild.innerHTML += getArrowIcon();
  } else {
    const infoChild = L.DomUtil.create(
      "div",
      createClasses("decidimGeo__drawer__listCardTitle"),
      infoTitle
    );
  }
  if (node.descriptionHtml) {
    const text = node.descriptionHtml[locale] || node.descriptionHtml[defaultLocale];
    if (text && !text.includes("Translation missing")) {
      const infoDescription = L.DomUtil.create(
        "div",
        "decidimGeo__drawer__listCardDescription decidimGeo__drawer__listCardDescription--large",
        container
      );
      infoDescription.innerHTML = text;
    }
  }
};
export default fallback;
